import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  productCategoriesService, 
  type ProductCategory, 
  type CreateProductCategoryData, 
  type UpdateProductCategoryData 
} from '@/services/productCategoriesService';

const QUERY_KEY = 'product-categories';

export const useProductCategoriesQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => productCategoriesService.getProductCategories(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useAllProductCategoriesQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY, 'all'],
    queryFn: () => productCategoriesService.getAllProductCategories(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateProductCategoryMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateProductCategoryData) => productCategoriesService.createProductCategory(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const useUpdateProductCategoryMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: UpdateProductCategoryData) => productCategoriesService.updateProductCategory(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const useDeleteProductCategoryMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => productCategoriesService.deleteProductCategory(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};